<template>
    <app-layout>
        <base-header :shadow="false" border border-bg-from="from-green-500" border-bg-to="to-teal-500">
            <div class="flex items-center justify-between w-full">
                <h4 class="text-xl font-medium">
                    {{ $t('general.companies') }}
                </h4>
                <inertia-link :href="route('companies.create')">
                    <default-button icon="plus" size="sm">
                        {{ $t('company.create') }}
                    </default-button>
                </inertia-link>
            </div>
        </base-header>

        <template>
            <table-base :busy="isLoading" class="text-sm">
                <template #head>
                    <table-head>{{ $t('general.name') }}</table-head>
                    <table-head>{{ $t('location.address') }}</table-head>
                    <table-head>{{ $t('location.postcode') }}</table-head>
                    <table-head>{{ $t('location.city') }}</table-head>
                    <table-head>{{ $t('location.country') }}</table-head>
                    <table-head></table-head>
                </template>
                <template #body>
                    <table-row v-for="company in companies.data" :key="company.id">
                        <table-cell>
                            {{ company.name }}
                        </table-cell>
                        <table-cell>
                            {{ company.address }}
                        </table-cell>
                        <table-cell>
                            {{ company.postcode }}
                        </table-cell>
                        <table-cell>
                            {{ company.city }}
                        </table-cell>
                        <table-cell>
                            {{ $t('country.' + company.country) }}
                        </table-cell>
                        <table-cell class="flex justify-end space-x-1">
                            <default-button
                                :href="route('companies.edit', company.id)"
                                icon="pencil"
                                size="xs"
                            />
                            <delete-button
                                :loading="isDeleting.includes(company.id)"
                                :modal-title="$t('company.delete')"
                                @delete="deleteCompany(company.id)"
                            >
                                <template #modal-body>
                                    {{ $t('company.delete_confirm') }}
                                </template>
                            </delete-button>
                        </table-cell>
                    </table-row>
                </template>
            </table-base>
            <table-pagination v-if="companies && companies.meta" :meta="companies.meta.pagination"
                              :links="companies.links"
                              @paginate="loadPage"
            />
        </template>
    </app-layout>
</template>

<script>
import Company from '@/Models/Company';

export default {
    metaInfo() {
        return {
            title: this.$t('general.companies'),
        };
    },

    data: function() {
        return {
            companies: null,
            isLoading: true,
            isDeleting: [],
        };
    },

    async created() {
        await this.loadPage(1);
    },

    methods: {
        async loadPage(page) {
            this.page = page;
            await this.applyQuery();
        },

        async applyQuery() {
            this.isLoading = true;
            this.companies = await Company.pageNumber(this.page).orderBy(this.sortQuery).all();
            this.isLoading = false;
        },

        deleteCompany(id) {
            this.$inertia.form({}).delete(route('companies.destroy', id), {
                onBefore: () => {
                    this.isDeleting.push(id);
                },
                onFinish: () => {
                    this.isDeleting.splice(this.isDeleting.indexOf(id), 1);
                    this.companies.data.splice(this.companies.data.findIndex(company => company.id === id), 1);
                },
            });
        },
    },
};
</script>
